import Component from '~/components/component';
import Swiper, { Autoplay, Navigation, Mousewheel } from 'swiper';

export default class PopinVideoSlider extends Component {
	constructor(...args) {
		super(...args);
		this.retrieveDOM();
		this.initSwiper();
	}

	retrieveDOM() {
		this.dom.slides = this.dom.component.querySelectorAll('.slide');
		this.dom.wrapper = this.dom.component.querySelector('.swiper-container');
		this.dom.prevButton = this.dom.component.querySelector('.button.prev');
		this.dom.nextButton = this.dom.component.querySelector('.button.next');

		this.dom.closeDiv = this.dom.component.querySelector('.backgroundClick');
		this.dom.video = this.dom.component.querySelector('.video');
		this.dom.buttonOpen = this.dom.component.querySelector('.openModal');
		this.dom.buttonClose = this.dom.component.querySelector('.closeModal');
		this.dom.dialog = this.dom.component.querySelector('.dialog');
	}

	bind() {
		this.dom.buttonOpen.addEventListener('click', this.openDialog);
		this.dom.buttonClose.addEventListener('click', this.closeDialog);
		this.dom.closeDiv.addEventListener('click', this.closeDialog);
	}

	closeDialog = () => {
		this.dom.dialog.close();
		this.dom.video.pause();
	};

	openDialog = () => {
		let url = this.dom.slides[this.swiper.realIndex].dataset.video;
		this.dom.video.src = url;
		this.dom.dialog.showModal();
		setTimeout(() => this.dom.video.play(), 100);
	};

	initSwiper() {
		this.swiper = new Swiper(this.dom.wrapper, {
			modules: [Autoplay, Navigation, Mousewheel],
			direction: 'horizontal',
			speed: 600,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			freeMode: false,
			loop: true,
			slidesPerView: 'auto',
			mousewheel: { forceToAxis: true },
			navigation: {
				prevEl: this.dom.prevButton,
				nextEl: this.dom.nextButton,
			},
		});
	}
}
